<template>
  <Layout>
    <div class="w-full max-w-4xl mx-auto px-4 lg:px-8 py-6">
      <!-- 面包屑 -->
      <div class="text-sm text-gray-500 mb-4">
        <router-link to="/" class="hover:text-primary">Home</router-link>
        <span class="mx-1">/</span>
        <router-link to="/product" class="hover:text-primary">Products</router-link>
        <span class="mx-1">/</span>
        <span class="text-gray-800">{{ productDetail?.name || 'Product Details' }}</span>
      </div>

      <!-- 产品主体：桌面端左右布局，移动端上下 -->
      <div class="flex flex-col lg:flex-row gap-8">
        <!-- 图片区 -->
        <div class="lg:w-1/2">
          <div class="relative aspect-square bg-gray-100 rounded-lg overflow-hidden group">
            <img v-if="activePhotoUrl" :src="activePhotoUrl" :alt="productDetail?.name" class="w-full h-full object-contain">
            <!-- 上一张 -->
            <button
              v-if="photoList.length > 1"
              type="button"
              title="previous"
              class="photo-prev-btn absolute left-2 top-1/2 -translate-y-1/2 w-10 h-10 flex items-center justify-center rounded-full bg-black/40 text-white opacity-80 hover:opacity-100 transition-opacity disabled:opacity-30"
              :disabled="activePhoto === 0"
              @click="previousPhoto"
            >
              <svg class="w-5 h-5" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" d="M15 19l-7-7 7-7"/></svg>
            </button>
            <!-- 下一张 -->
            <button
              v-if="photoList.length > 1"
              type="button"
              title="next"
              class="photo-next-btn absolute right-2 top-1/2 -translate-y-1/2 w-10 h-10 flex items-center justify-center rounded-full bg-black/40 text-white opacity-80 hover:opacity-100 transition-opacity disabled:opacity-30"
              :disabled="activePhoto === photoList.length - 1"
              @click="nextPhoto"
            >
              <svg class="w-5 h-5" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" d="M9 5l7 7-7 7"/></svg>
            </button>
          </div>
          <div v-if="photoList.length > 1" class="flex gap-2 mt-3 overflow-x-auto">
            <div
              v-for="(photo, index) in photoList" :key="index"
              class="w-16 h-16 flex-shrink-0 rounded border-2 cursor-pointer overflow-hidden"
              :class="activePhoto === index ? 'border-primary' : 'border-gray-200'"
              @click="setActivePhoto(index)"
            >
              <img :src="photo" class="w-full h-full object-cover">
            </div>
          </div>
        </div>

        <!-- 信息区 -->
        <div class="lg:w-1/2">
          <h1 class="text-2xl lg:text-3xl font-bold text-gray-800 mb-4">{{ productDetail?.name }}</h1>

          <div v-if="productDetail?.specifications?.length" class="mb-6">
            <h3 class="text-lg font-bold mb-3">Specifications</h3>
            <div class="grid grid-cols-2 gap-2">
              <div v-for="(spec, index) in productDetail.specifications" :key="index" class="flex border-b border-gray-100 pb-2">
                <span class="text-gray-500 text-sm w-24 flex-shrink-0">{{ spec.label }}</span>
                <span class="text-gray-800 text-sm">{{ spec.value }}</span>
              </div>
            </div>
          </div>

          <div v-if="productDetail?.introduction" class="mb-6">
            <h3 class="text-lg font-bold mb-2">Description</h3>
            <p class="text-gray-600 text-sm">{{ productDetail.introduction }}</p>
          </div>

          <button class="w-full lg:w-auto px-8 py-3 bg-primary hover:bg-primary-dark text-white rounded-lg transition-colors text-lg min-h-[44px]" @click="onInquiry">
            Inquiry Now
          </button>
        </div>
      </div>

      <!-- 询价弹窗 -->
      <el-dialog v-model="inquiryVisible" title="Get Quotation" width="90%" :close-on-click-modal="false" class="max-w-lg">
        <div class="space-y-4">
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-1">* Email</label>
            <input type="email" v-model="inquiryForm.email" class="w-full border border-gray-300 rounded-lg px-3 py-2 min-h-[44px]">
          </div>
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-1">* Phone</label>
            <input type="tel" v-model="inquiryForm.phone" class="w-full border border-gray-300 rounded-lg px-3 py-2 min-h-[44px]">
          </div>
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-1">Message</label>
            <textarea v-model="inquiryForm.message" rows="3" class="w-full border border-gray-300 rounded-lg px-3 py-2"></textarea>
          </div>
          <button class="w-full py-3 bg-primary hover:bg-primary-dark text-white rounded-lg min-h-[44px]">Submit</button>
        </div>
      </el-dialog>
    </div>
  </Layout>
</template>

<script>
import Layout from "@/components/common/CommonLayout";
import { productDetails } from "@/data/productData";

export default {
  name: "ProductDetailsView",
  components: {Layout},
  data() {
    return {
      name: '',
      title: '',
      introduction: '',
      specifications: [],
      activePhoto: 0,
      photos: [],
      tabIndex: 0,
      quantity: 1,
      formData: {
        name: '',
        email: '',
        phone: '',
        company: '',
        message: ''
      },
      tabList: [
        {typeId: 0, typeName: 'details', menuName: 'Details'},
        {typeId: 1, typeName: 'more', menuName: 'More'}
      ],
      activeMenu: 'details',
      productData: null,
      inquiryVisible: false,
      inquiryForm: { email: '', phone: '', message: '' }
    }
  },
  computed: {
    currentMenuTitle() {
      return this.activeMenu === 'details' ? this.name : 'Get quotation';
    },
    productDetail() {
      return {
        name: this.name,
        specifications: this.specifications,
        introduction: this.introduction
      }
    },
    activePhotoUrl() {
      return this.photos.length > 0 ? this.photos[this.activePhoto] : ''
    },
    photoList() {
      return this.photos
    }
  },
  mounted() {
    this.fetchProduct(this.$route.params.productId)
    if (this.$route.query.tab === 'more') {
      this.activeMenu = 'more'
      this.tabIndex = 1
    }
  },
  methods: {
    changeTab(index, typeName) {
      this.tabIndex = index;
      this.activeMenu = typeName;
    },
    sendInquiry() {
      // TODO: 实现发送咨询逻辑
      console.log('Send inquiry');
    },
    submitQuotation() {
      // TODO: 实现提交报价逻辑
      console.log('Submit quotation', this.formData, this.quantity);
    },
    async fetchProduct(productId) {
      const resp = await this.getRequest(`/api/products/${productId}`)
      if (resp && resp.data && resp.data.data) {
        const p = resp.data.data
        this.name = p.name || ''
        this.title = p.name || ''
        this.introduction = p.description || ''
      }
      // Fetch specifications separately
      const specResp = await this.getRequest(`/api/products/${productId}/specifications`)
      if (specResp && specResp.data) {
        this.specifications = specResp.data.data || []
      }
      // 组装产品图片列表：优先使用本地 productDetails 配置，支持多张图片
      const localDetail = productDetails[productId]
      const photoList = []
      if (localDetail) {
        if (localDetail.imageUrl1) photoList.push(localDetail.imageUrl1)
        if (localDetail.imageUrl2) photoList.push(localDetail.imageUrl2)
      }
      if (photoList.length === 0) {
        photoList.push('/images/product/products-' + productId + '.jpg')
      }
      this.photos = photoList
      this.activePhoto = 0
    },
    nextPhoto() {
      this.activePhoto = (this.activePhoto + 1 < this.photos.length ? this.activePhoto + 1 : 0)
    },
    previousPhoto() {
      this.activePhoto = (this.activePhoto - 1 >= 0 ? this.activePhoto - 1 : this.photos.length - 1)
    },
    onInquiry() { this.inquiryVisible = true },
    setActivePhoto(index) { this.activePhoto = index }
  }
}
</script>
